import * as React from "react";
const SvgChevronUp = (props) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", height: "24px", viewBox: "0 -960 960 960", width: "24px", fill: "currentColor", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M480-528 296-344l-56-56 240-240 240 240-56 56-184-184Z" }));
export default SvgChevronUp;
